import type { TypePolicies } from '@apollo/client'
import type {
  BoundingBoxFilterInput,
  InputMaybe,
  ServiceArea,
} from '@backoffice-frontend/graphql'
import { getStoreBoundingBoxTerm } from './boundingBoxTerm.local'

// Apollo local store
export const StopNetworkStore: TypePolicies = {
  Query: {
    fields: {
      // === Improve caching of remote queries ===
      // Note(Filip): Fixes the following warning: "Cache data may be lost when replacing the serviceAreaById field of a Query object."
      serviceAreaById: {
        merge(_, incoming: Partial<ServiceArea>) {
          return incoming
        },
      },
      allChanges: {
        keyArgs: [
          'type',
          'id',
          'startDate',
          'endDate',
          'fieldChanged',
          'serviceAreaId',
        ],
        merge(existing, incoming, { args }) {
          // First-page fetch (no cursor) replaces the cache to avoid
          // duplicating items when the same entity is re-visited.
          if (!args?.nextCursor) {
            return incoming
          }
          return {
            ...incoming,
            items: [...(existing?.items ?? []), ...incoming.items],
          }
        },
      },
      storeBoundingBoxTerm: {
        read(): InputMaybe<BoundingBoxFilterInput> {
          return getStoreBoundingBoxTerm()
        },
      },
    },
  },
}
